import { useI18n } from 'vue-i18n'
import * as Sentry from '@sentry/vue'
import { ApiError } from '@/client'

type Context = Record<string, unknown>

export function getApiErrorMessage(
  error: ApiError,
  i18n: ReturnType<typeof useI18n>,
  defaultMessage?: string
): string {
  let translation
  if (
    error.body?.detail?.error &&
    i18n.te(error.body.detail.error + '.message')
  ) {
    translation = i18n.t(error.body.detail.error + '.message')
  } else if (defaultMessage) {
    translation = defaultMessage
  } else if (error.body?.detail?.message)
    translation = error.body?.detail?.message
  else translation = i18n.t('error.unknown.unknown_error.message')
  return translation
}

export function logError(
  error: unknown,
  message?: string,
  context?: Context,
  tags?: Record<string, string>
) {
  const err =
    error instanceof Error ? error : new Error(String(error || 'Unknown error'))

  if (message) {
    Sentry.addBreadcrumb({
      category: 'error',
      message,
      data: context,
      level: 'error',
    })
  }

  Sentry.captureException(err, {
    tags,
    contexts: context ? { context } : undefined,
  })

  return err
}
